export default __webpack_public_path__ + "img/markup_tools/visibility_toggle.svg";